import React from "react";
import ProductsListing from "./ProductsListing";
import { useParams } from "react-router-dom";

function Products() {
  let { subnetId, locationId, useCaseId, tagId } = useParams();

  const type = "all";
  const title = "All Products";

  return (
    <ProductsListing
      type={type}
      title={title}
      subnetId={subnetId}
      locationId={locationId}
      useCaseId={useCaseId}
      tagId={tagId}
    />
  );
}

export default Products;
